export default {
  API_ORIGIN: null,
  API_URL: null,
  searched: false,
  searchResult: [],
  cashSearchResult: [],
  mainParams: null,
  urlParams: "",
  lastRequest: "",
  quotaDescription: {},
  datesISO: [],
  showQuotes: false,
  firstPageLoadFlag: true
}